import { Box, Breadcrumbs, Grid2, Paper, Stack, Typography } from "@mui/material";
import { useContext, useState } from "react";
import Main from "../components/Main";
import { Link } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SideMenu from "../components/SideMenu";
import AppNavBar from "../components/AppNavBar";
import AppBottomNavigation from "../components/AppBottomNavigation";
import UpdatePassword from "../components/UpdatePassword";
import ProfileForm from "../components/ProfileForm";
import getHomeLink from "../utils/getHomeLink";
import { AuthContext } from "../utils/AuthContext";


const Profile = () => {
    const [open, setOpen] = useState(localStorage.getItem('drawer-open') == 'true');

    const { auth } = useContext(AuthContext);

    const toggleDrawer = () => {
        localStorage.setItem('drawer-open', !open);
        setOpen(!open);
    };

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const breadcrumbs = [
        <Link sx={{ textDecoration: 0 }} key="1" color="inherit" to={getHomeLink(auth)}>
            Home
        </Link>,
        // <Link
        //     underline="hover"
        //     key="2"
        //     color="inherit"
        //     href="/material-ui/getting-started/installation/"
        //     onClick={handleClick}
        // >
        //     Core
        // </Link>,
        <Typography key="2" sx={{ color: 'text.primary' }}>
            Profile Setting
        </Typography>,
    ];



    return (
        <Box sx={{
            backgroundColor: '#ededed',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // Ensure no vertical scrollbar
        }}>
            {/* <MainHeader open={open} setOpen={setOpen} /> */}
            <AppNavBar currentPage='profile' />
            <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
                <SideMenu currentPage='profile' />

                <Main
                    open={open}
                    sx={{
                        // height: '100%',
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        marginLeft: {
                            xs: 0,
                            md: 1
                        },
                        backgroundColor: '#fff',
                        mt: 7,
                        mb: 2,
                        marginRight: {
                            xs: 0,
                            md: 1
                        },
                        borderRadius: {
                            xs: 0,
                            md: 2
                        },
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        px: {
                            xs: 2,
                            md: 3
                        },
                        py: 2
                    }} >
                    <Typography variant="h1" sx={{ fontSize: 24, mb: 1 }}>
                        Profile
                    </Typography>

                    <Stack sx={{
                        display: {
                            xs: 'none',
                            md: 'block'
                        }
                    }} spacing={2}>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                        >
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Stack>

                    <Grid2 container sx={{ mt: 3, mb: 5 }} spacing={7}>
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <ProfileForm />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <UpdatePassword />
                        </Grid2>
                    </Grid2>


                    {/* Bottom Navigation */}
                    <Paper sx={{
                        zIndex: 9997,
                        display: {
                            xs: 'block',
                            md: 'none'
                        }, position: 'fixed', bottom: 0, left: 0, right: 0
                    }} elevation={3}>
                        <AppBottomNavigation currentPage="profile" />
                    </Paper>
                </Main >
            </Box>
        </Box >
    );
}

export default Profile